 export default function ShowComments({comments}){

    const commentArray = comments.split(';');

    return(
        <div style={{display: 'flex', justifyContent: 'flex-end' }}>
            <tbody className="float-end">
             <ul style={{ textAlign: 'left', listStyleType: 'none', padding: 0, float:'right'}}>
            {commentArray.map(v => (
                <li>{v}</li>
            ))}
            </ul>
            </tbody>
        </div>
    );
}